import { render, staticRenderFns } from "./palletinfo1.vue?vue&type=template&id=05437b76"
import script from "./palletinfo1.vue?vue&type=script&lang=js"
export * from "./palletinfo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports